// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__18eh2","author":"Table_author__30Hxm","authorImage":"Table_authorImage__3e1Xl","unreadRow":"Table_unreadRow__2dCI5"};